import { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { joinWaitlist, subscribeNewsletter } from '../api';

export default function EmailCaptureForm({ mode = 'waitlist', source = 'website', dark = false, buttonLabel }) {
  const { t, lang } = useLanguage();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setMessage('');
    try {
      const res =
        mode === 'newsletter'
          ? await subscribeNewsletter(email, lang)
          : await joinWaitlist(email, { source, language: lang });
      setStatus('done');
      setMessage(res.message || '');
    } catch (err) {
      setStatus('error');
      setMessage(err.message);
    }
  };

  if (status === 'done') {
    return (
      <div className="form__done" role="status">
        <b><span className="tick">✓</span> {t('form.thanksTitle')}</b>
        <p style={{ opacity: 0.85 }}>{message || t('form.thanksBody')}</p>
      </div>
    );
  }

  const label = buttonLabel || (mode === 'newsletter' ? t('cta.subscribe') : t('cta.earlyAccess'));

  return (
    <form className="form" onSubmit={submit} noValidate>
      <div className="form__row">
        <input
          className="input"
          type="email"
          required
          placeholder={t('hero.email')}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          aria-label="Email address"
          disabled={status === 'loading'}
        />
        <button className="btn btn--primary" type="submit" disabled={status === 'loading'}>
          {status === 'loading' ? '…' : label}
        </button>
      </div>
      {status === 'error' && <p className="form__msg form__msg--err">{message}</p>}
    </form>
  );
}
